import { useState } from "react";

export default function useCloseConfirm(onClose) {
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);

  const openCloseConfirm = () => {
    setShowCloseConfirm(true);
  };

  const cancelCloseConfirm = () => {
    setShowCloseConfirm(false);
  };

  const confirmCloseConfirm = () => {
    cancelCloseConfirm();
    onClose();
  };
  return {
    showCloseConfirm,
    openCloseConfirm,
    cancelCloseConfirm,
    confirmCloseConfirm,
  };
}
